import { Stack } from "@mui/material";
import { CustomPriceSelector } from "../../../positions-and-orders/controls";

export function PortfolioBalancerToolsPanel() {
    return (
        <Stack
            direction="row"
            spacing={1}
        >
            <CustomPriceSelector />
        </Stack>
    );
}
